import React from 'react';

import { css, styled } from 'styled-components';

import GenericContainer from 'components/GenericContainer';
import HeaderLogo, { HeaderLogoVariant } from 'components/HeaderLogo/HeaderLogo';
import { AlertSize } from 'components/Layout/Header/components/AlertBanner';

const SuperNavWrapper = styled('div')<{ $scrollUp: boolean; $alertOpen: boolean }>(
  ({ theme, $scrollUp, $alertOpen }) => css`
    position: sticky;
    top: ${$alertOpen ? AlertSize.lg : '0'};
    width: 100%;
    height: 2.5rem;
    visibility: ${$scrollUp ? 'hidden' : 'visible'};
    transform: ${$scrollUp ? 'translateY(-100%)' : 'none'};
    transition: all 0.5s;
    background-color: ${theme.colors.primaryBlack2};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
      display: none;
    }
  `
);

const SuperNavContainer = styled.div<{ $hasLogo: boolean }>(
  ({ $hasLogo }) => css`
    display: flex;
    align-items: center;
    justify-content: ${$hasLogo ? 'space-between' : 'flex-end'};
  `
);

const NavContainer = styled.nav(
  () => css`
    display: flex;
    align-items: center;
    gap: 1rem;
  `
);

interface SuperNavProps {
  children: React.ReactNode;
  scrollDirection?: string;
  alertOpen: boolean;
  showLogo?: boolean;
}

const SuperNav: React.FC<SuperNavProps> = ({ children, scrollDirection, alertOpen, showLogo = false }) => (
  <SuperNavWrapper $scrollUp={scrollDirection === 'up'} $alertOpen={alertOpen} data-testid='super-nav-test-id'>
    <GenericContainer>
      <SuperNavContainer $hasLogo={showLogo}>
        {showLogo && <HeaderLogo variant={HeaderLogoVariant.WHITE} />}
        <NavContainer>{children}</NavContainer>
      </SuperNavContainer>
    </GenericContainer>
  </SuperNavWrapper>
);

export default SuperNav;
